import { stringifyGraph } from '@/clients/http'
import { OfferModel } from '@/http/models/Offer'
import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'
import { OfferHttpParams, OfferModel as OfferModelType } from '@/types'

export interface CampaignListFilters {
  search?: string
  status?: OfferModelType.Status | null
  applies_to?: OfferModelType.AppliesTo | null
}

export interface CampaignListForm extends UseFetchListForm<
  CampaignListFilters,
  OfferModelType.Offer
> {}

export const campaignInitialFilters: CampaignListFilters = {
  search: '',
  status: null,
  applies_to: null,
}

/** `appliesTo` fixes the channel (Point of sale → Offers lists POS-only offers); without it every offer is listed. */
export const useFetchCampaigns = ({ sort, appliesTo }: { sort?: string | null; appliesTo?: OfferModelType.AppliesTo }) => {
  return useFetchList<
    CampaignListFilters,
    OfferModelType.Offer,
    {},
    any,
    typeof OfferModel.getList
  >({
    pageSize: 12,
    initialFilters: { ...campaignInitialFilters, applies_to: appliesTo ?? null },
    fetchFunction: OfferModel.getList,
    sort,
    register: true,
    buildQueryParams: (filters): Partial<OfferHttpParams.GetList['query']> => ({
      applies_to: appliesTo ?? (filters.applies_to || undefined),
      search: filters.search || undefined,
      status: filters.status || undefined,
      graph_enc: stringifyGraph({ '*': true }),
    }),
    buildParams: () => ({}),
  })
}
